import React, { useState, useEffect } from "react";
import {
    IconButton, Avatar, Menu, MenuItem, Divider, ListItemIcon, ListItemText, CircularProgress,
    Dialog, DialogTitle, DialogActions, Button, TextField, DialogContent, useMediaQuery
} from "@mui/material";

import { useTheme } from "@mui/material/styles";

import DescriptionIcon from "@mui/icons-material/Description";
import EditNoteRoundedIcon from '@mui/icons-material/EditNoteRounded';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
import BlockIcon from '@mui/icons-material/Block';
import GavelRoundedIcon from '@mui/icons-material/GavelRounded';
import CreditCardRoundedIcon from "@mui/icons-material/CreditCardRounded";

import RocketLaunchRoundedIcon from '@mui/icons-material/RocketLaunchRounded';

import CloseIcon from '@mui/icons-material/Close';

import PaymentMethodDialog from "../Billing/PaymentMethodDialog";
import UpgradePlanDialog from "../Billing/UpgradePlanDialog";

import { useAuth } from "../../contexts/AuthContext";
import { usePlano } from "../../contexts/PlanContext";
import { useSnackbar } from "../../contexts/SnackbarContext";

import { useNavigate } from "react-router-dom";

import EditAccountDialog from "../User/EditAccountDialog";

import TermoUsoConteudo from "../Legal/TermoUso";

import api from '../../services/api';
import { getApiErrorMessage, normalizePlan } from '../../services/apiUtils';

export default function AvatarMenu() {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    const [anchorEl, setAnchorEl] = useState(null);
    const [openEdit, setOpenEdit] = useState(false);

    const [openTermoModal, setOpenTermoModal] = useState(false);

    const [openCancelDialog, setOpenCancelDialog] = useState(false);
    const [cancelLoading, setCancelLoading] = useState(false);
    const [motivoCancelamento, setMotivoCancelamento] = useState("");

    const [openPagamento, setOpenPagamento] = useState(false);
    const [openUpgrade, setOpenUpgrade] = useState(false);

    const { user, logout } = useAuth();
    const navigate = useNavigate();

    const { planoTipo, fetchStatusPlano } = usePlano();
    const { showSnackbar } = useSnackbar();

    // Adicione estados para status e plano (tipo de plano)
    const [planName, setPlanNaame] = useState(null);
    const [planoStt, setPlanoStt] = useState(null); // "A", "P", "G", "C"
    const [paymentMethod, setPaymentMethod] = useState(null);
    const [creditCardToken, setCreditCardToken] = useState(null);
    //const [tipoPlano, setTipoPlano] = useState(null);     // "EMPRESA", "CONTADOR", null

    // Busca status e tipo de plano ao abrir menu
    useEffect(() => {
        async function fetchStatus() {
            if (!user?.id) return;
            try {
                const res = await api.get('/billing/plan');
                const plan = normalizePlan(res.data);

                setPlanoStt(plan?.status || null);
                setPlanNaame(plan?.planName);
                setPaymentMethod(plan?.paymentMethod)
                setCreditCardToken(plan?.creditCardToken)
            } catch {
                setPlanoStt(null);
                setPlanNaame(null);
            }
        }
        if (anchorEl) fetchStatus();
    }, [anchorEl, user]);

    const handleMenu = (event) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);
    const handleOpenTutorial = () => {
        handleClose();
        window.open("/tutorial", "_blank", "noopener,noreferrer");
    };

    // ---- Cancelamento do Plano ----
    const handleCancelarPlano = async () => {
        setCancelLoading(true);
        try {
            await api.patch('/billing/subscription/cancel', {
                reason: motivoCancelamento.trim() || "Cancelado pelo usuário."
            });
            setCancelLoading(false);
            setOpenCancelDialog(false);
            setPlanoStt("C");
            setMotivoCancelamento("");
            handleClose();
            window.location.reload();
        } catch (err) {
            setCancelLoading(false);
            showSnackbar(getApiErrorMessage(err, "Erro ao cancelar plano. Tente novamente."), "error");
        }
    };

    // Link do WhatsApp de suporte
    const whatsappURL = "https://wa.me/5524998359874?text=Ol%C3%A1%2C+quero+saber+mais+sobre+a+sua+solu%C3%A7%C3%A3o+Docen!";

    return (
        <>
            <IconButton size="large" onClick={handleMenu}>
                <Avatar sx={{ bgcolor: "#bdbdbd" }}>
                    {user?.name?.[0]?.toUpperCase() || "U"}
                </Avatar>
            </IconButton>
            <Menu anchorEl={anchorEl} open={!!anchorEl} onClose={handleClose} sx={{ mt: 1 }}>
                <MenuItem onClick={() => { handleClose(); setOpenEdit(true); }}>
                    <ListItemIcon>
                        <EditNoteRoundedIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Editar Conta</ListItemText>
                </MenuItem>

                <Divider />

                {(planoStt === "A" || planoStt === "P") && ([

                    ...((paymentMethod === "CARD" || paymentMethod === "CREDIT_CARD") && creditCardToken !== undefined && creditCardToken !== null ? [(
                        <MenuItem key="pay" onClick={() => { handleClose(); setOpenPagamento(true); }}>
                            <ListItemIcon><CreditCardRoundedIcon fontSize="small" /></ListItemIcon>
                            <ListItemText>Dados de Pagamento</ListItemText>
                        </MenuItem>
                    )] : []),

                    ...(planoStt === "A" && planName !== "MESTRE" ? [(
                        <MenuItem key="upgrade" onClick={() => { handleClose(); setOpenUpgrade(true); }}>
                            <ListItemIcon><RocketLaunchRoundedIcon fontSize="small" /></ListItemIcon>
                            <ListItemText>Atualizar Plano</ListItemText>
                        </MenuItem>
                    )] : []),

                    <MenuItem
                        key="cancel"
                        onClick={() => { setOpenCancelDialog(true); handleClose(); }}
                        disabled={cancelLoading}
                        sx={{ color: "error.main", fontWeight: 500 }}
                    >
                        <ListItemIcon><BlockIcon fontSize="small" sx={{ color: "error.main" }} /></ListItemIcon>
                        <ListItemText>Cancelar Plano</ListItemText>
                        {cancelLoading && <CircularProgress size={16} sx={{ ml: 1 }} />}
                    </MenuItem>,

                    <Divider key="div-after-billing" />,
                ])}



                <MenuItem onClick={handleOpenTutorial}>
                    <ListItemIcon>
                        <DescriptionIcon fontSize="small" color="primary" />
                    </ListItemIcon>
                    <ListItemText>Tutorial</ListItemText>
                </MenuItem>

                <MenuItem
                    component="a"
                    href={whatsappURL}
                    target="_blank"
                    rel="noopener"
                    onClick={handleClose}
                >
                    <ListItemIcon>
                        <WhatsAppIcon fontSize="small" sx={{ color: "#25d366" }} />
                    </ListItemIcon>
                    <ListItemText>Suporte</ListItemText>
                </MenuItem>
                <Divider />

                <MenuItem onClick={() => { handleClose(); setOpenTermoModal(true); }}>
                    <ListItemIcon>
                        <GavelRoundedIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Termo de Uso</ListItemText>
                </MenuItem>
                <MenuItem
                    onClick={() => { handleClose(); logout(); navigate("/login"); }}
                    sx={{
                        color: "",
                        "&:hover": {
                            color: "#B22222",
                            "& .MuiListItemIcon-root": { color: "#B22222" },
                            "& .MuiListItemIcon-root svg": { color: "#B22222" },
                        },
                    }}
                >
                    <ListItemIcon>
                        <LogoutRoundedIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Sair</ListItemText>
                </MenuItem>

            </Menu>
            <EditAccountDialog open={openEdit} onClose={() => setOpenEdit(false)} />

            {/* Diálogo de confirmação de cancelamento */}
            <Dialog
                open={openCancelDialog}
                onClose={() => !cancelLoading && setOpenCancelDialog(false)}
                fullWidth
                maxWidth="sm"
                fullScreen={isMobile}
                PaperProps={{
                    sx: {
                        p: 0,
                        borderRadius: isMobile ? 0 : 3,
                    },
                }}
            >

                <DialogTitle sx={{ pb: 2 }}>Deseja cancelar o plano?
                    <IconButton onClick={() => setOpenCancelDialog(false)} sx={{ position: "absolute", right: 8, top: 10 }}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent sx={{ pb: 1 }}>
                    <TextField
                        label="Motivo do Cancelamento"
                        placeholder="Preencha o motivo do cancelamento..."
                        multiline
                        minRows={3}
                        fullWidth
                        value={motivoCancelamento}
                        onChange={e => setMotivoCancelamento(e.target.value)}
                        variant="outlined"
                        autoFocus
                        sx={{ mt: 1 }}
                        disabled={cancelLoading}
                    />
                </DialogContent>
                <DialogActions sx={{
                    p: 2,
                    position: isMobile ? "fixed" : "static",
                    bottom: isMobile ? 0 : "auto",
                    left: isMobile ? 0 : "auto",
                    right: isMobile ? 0 : "auto",
                    bgcolor: isMobile ? "background.paper" : "transparent",
                    borderTop: isMobile ? `1px solid ${theme.palette.divider}` : "none",
                    zIndex: 10
                }}>
                    <Button onClick={() => setOpenCancelDialog(false)} disabled={cancelLoading}>Fechar</Button>
                    <Button
                        onClick={handleCancelarPlano}
                        variant="contained"
                        color="error"
                        disabled={cancelLoading || motivoCancelamento.trim().length === 0}
                    >
                        {cancelLoading ? <CircularProgress size={20} /> : "Cancelar"}
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Modal termo de uso */}
            <Dialog
                open={openTermoModal}
                onClose={() => setOpenTermoModal(false)}
                scroll="paper"
                fullWidth
                maxWidth="sm"
                fullScreen={isMobile}
                PaperProps={{
                    sx: {
                        p: 0,
                        borderRadius: isMobile ? 0 : 3
                    }
                }}
            >
                <DialogTitle>Termo de Uso
                    <IconButton onClick={() => setOpenTermoModal(false)} sx={{ position: "absolute", right: 8, top: 10 }}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent dividers sx={{ overflowY: 'auto' }}>
                    <TermoUsoConteudo />
                </DialogContent>
                <DialogActions sx={{
                    p: 2,
                    position: isMobile ? "fixed" : "static",
                    bottom: isMobile ? 0 : "auto",
                    left: isMobile ? 0 : "auto",
                    right: isMobile ? 0 : "auto",
                    bgcolor: isMobile ? "background.paper" : "transparent",
                    borderTop: isMobile ? `1px solid ${theme.palette.divider}` : "none",
                    zIndex: 10
                }}>
                    <Button onClick={() => setOpenTermoModal(false)} color="primary" variant="outlined">
                        Fechar
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Dialog de informações d epagamento */}
            <PaymentMethodDialog
                open={openPagamento}
                onClose={() => setOpenPagamento(false)}
                userId={user?.id}
            />

            {/* Dialog para atualizar plano */}
            <UpgradePlanDialog
                open={openUpgrade}
                onClose={() => setOpenUpgrade(false)}
                userId={user?.id}
                planoAtual={planoTipo}
                onUpgraded={async () => {
                    await fetchStatusPlano(user?.id);
                    showSnackbar("Plano atualizado com sucesso!", "success");
                }}

            />


        </>
    );
}
